import React, { useEffect, useState } from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
  TextField,
  CircularProgress,
  Box,
  TableSortLabel,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Fade,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Link,
  IconButton,
} from "@mui/material";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import {
  CancelOutlined,
  CheckCircleOutline,
  DisabledByDefault,
  DownloadForOffline,
  HourglassBottom,
  Preview,
} from "@mui/icons-material";
import VerifiedIcon from "@mui/icons-material/Verified";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import FilePresentRoundedIcon from "@mui/icons-material/FilePresentRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import ImageView from "../../../components/Dashboard/ImageView/ImageView";
import noImageAvailable from "../../../assets/images/png/no-image-available.png";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import DDateInput from "../../../components/Dashboard/DashboardInputs/DDateInput";
import { emptyCheck } from "../../../utils/validations";
import { useSelector } from "react-redux";

const formatDate = (isoDate) => {
  if (!isoDate) return "NA";
  const date = new Date(isoDate);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const VendorApproval = () => {
  const [loading, setLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [statusFilter, setStatusFilter] = useState("all");

  const [open, setOpen] = useState(false);
  const [selectVendor, setSelectVendor] = useState(null);

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const loginData = useSelector((state) => state.loginData.value);
  const access_type = loginData?.access_type;
  const org_token = loginData?.organization_token;

  // date filter
  const [startDateSearchQuery, setStartDateSearchQuery] = useState({
    value: "",
    isValid: true,
  });

  const [endDateSearchQuery, setEndDateSearchQuery] = useState({
    value: "",
    isValid: true,
  });

  // Sorting
  const [sortConfig, setSortConfig] = useState({
    key: "company_name",
    direction: "asc",
  });

  const getAllVendors = async (
    newPage = page,
    newRowsPerPage = rowsPerPage,
    newSort = sortConfig,
    newSearch = searchTerm,
    newStatus = statusFilter
  ) => {
    try {
      setLoading(true);

      // Prepare date parameters for API - Use correct parameter names
      const dateParams = {};
      if (startDateSearchQuery.value) {
        const fromDate = new Date(startDateSearchQuery.value);
        dateParams.from_date = fromDate.toISOString().split("T")[0];
      }
      if (endDateSearchQuery.value) {
        const toDate = new Date(endDateSearchQuery.value);
        dateParams.to_date = toDate.toISOString().split("T")[0];
      }

      const requestData = {
        org_token: org_token,
        page: newPage + 1,
        page_size: newRowsPerPage,
        sort_key: newSort.key,
        sort_order: newSort.direction,
        search: newSearch,
        status: newStatus,
        ...dateParams,
      };

      const res = await axios.post(
        API_ENDPOINT.get_all_vendors_approval,
        requestData
      );

      console.log("API Response:", res.data);
      setVendors(res.data.results || []);
      setTotalCount(res.data.total_count || 0);
    } catch (err) {
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllVendors();
  }, []);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
    getAllVendors(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    const newRows = parseInt(e.target.value, 10);
    setRowsPerPage(newRows);
    setPage(0);
    getAllVendors(0, newRows);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    const handleStatusChange = (event) => {
      const newStatus = event.detail?.status;
      if (newStatus) {
        setStatusFilter(newStatus);
        getAllVendors(0, rowsPerPage, sortConfig, searchTerm, newStatus);
      }
    };

    window.addEventListener("approvalStatusChanged", handleStatusChange);

    return () => {
      window.removeEventListener("approvalStatusChanged", handleStatusChange);
    };
  }, []);

  useEffect(() => {
    const storedStatus = localStorage.getItem("approval_status");
    if (storedStatus) {
      setStatusFilter(storedStatus);
      getAllVendors(0, rowsPerPage, sortConfig, searchTerm, storedStatus);
    } else {
      getAllVendors();
    }
  }, []);

  useEffect(() => {
    if (statusFilter) {
      getAllVendors(0, rowsPerPage, sortConfig, searchTerm, statusFilter);
    }
  }, [
    statusFilter,
    sortConfig,
    searchTerm,
    rowsPerPage,
    startDateSearchQuery.value,
    endDateSearchQuery.value,
  ]);

  // useEffect(() => {
  //   getAllVendors();
  // }, [searchTerm, statusFilter, sortConfig, startDateSearchQuery.value, endDateSearchQuery.value]);

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;
    const { action, status } = JSON.parse(chatActionRaw);
    if (action === "navigate_to_tracker_pending") {
      setStatusFilter(String(status));
    }
    sessionStorage.removeItem("CHAT_ACTION");
  }, []);

  const handleOpen = (vendor) => {
    setSelectVendor(vendor);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sortedVendors = [...vendors]
    .filter((vendor) => {
      const lowerSearch = searchTerm.toLowerCase();
      const statusTextMap = {
        approved: "1",
        pending: "2",
        rejected: "3",
      };
      const mappedStatus = statusTextMap[lowerSearch] || "";

      return (
        vendor.company_name?.toLowerCase().includes(lowerSearch) ||
        vendor.first_name?.toLowerCase().includes(lowerSearch) ||
        vendor.last_name?.toLowerCase().includes(lowerSearch) ||
        vendor.company_official_email?.toLowerCase().includes(lowerSearch) ||
        String(vendor.is_approved) === mappedStatus
      );
    })
    .filter((vendor) => {
      if (statusFilter === "all") return true;
      return String(vendor.is_approved) === statusFilter;
    })
    .sort((a, b) => {
      const aVal = a[sortConfig.key]?.toString().toLowerCase() || "";
      const bVal = b[sortConfig.key]?.toString().toLowerCase() || "";
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

  // const paginatedVendors = sortedVendors.slice(
  //   page * rowsPerPage,
  //   page * rowsPerPage + rowsPerPage
  // );

  const renderSortLabel = (columnKey, label) => (
    <TableSortLabel
      active={sortConfig.key === columnKey}
      direction={sortConfig.direction}
      onClick={() => handleSort(columnKey)}
      sx={{
        "& .MuiTableSortLabel-icon": {
          opacity: 1,
          color: "inherit !important",
        },
        "&.MuiTableSortLabel-root": {
          color: "inherit",
        },
        "&.MuiTableSortLabel-root:hover": {
          color: "inherit",
          backgroundColor: "transparent",
        },
        "&.MuiTableSortLabel-root.Mui-focusVisible": {
          backgroundColor: "transparent",
        },
      }}
      IconComponent={UnfoldMoreIcon}
    >
      {label}
    </TableSortLabel>
  );

  const approveVendor = async (vendorToken, action) => {
    try {
      await axios.post(API_ENDPOINT.vendor_approve, {
        vendor_token: vendorToken,
        action: action,
      });
      getAllVendors();
    } catch (err) {
      console.error("Approval failed", err);
    }
  };

  return (
    <Fade in={true} timeout={400}>
      <Box sx={{ p: 3 }}>
        <HeaderTitle titleText="Vendor Onboarding Approval" />

        {/* ===== Filters Section ===== */}
        {/* ===== Filters Section ===== */}
        <Box
          mb={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
        >
          {/* Search Bar - At Start */}
          <SearchBar
            value={searchTerm}
            onChange={(query) => {
              setSearchTerm(query);
              setPage(0);
            }}
          />

          {/* Date Filters and Status - At End */}
          <Box display="flex" alignItems="center" gap={2}>
            {/* Date Filters */}
            <Box display="flex" alignItems="center" gap={1}>
              <DDateInput
                type={"date"}
                label={"From Date"}
                disableFuture={true}
                onChange={(e) => {
                  setPage(0);
                  setStartDateSearchQuery({
                    isValid: emptyCheck(e),
                    value: e,
                  });
                }}
                value={startDateSearchQuery}
                error={!startDateSearchQuery?.isValid}
                errorMsg={"From date is required"}
                size={"16rem"}
              />

              <DDateInput
                type={"date"}
                label={"To Date"}
                disableFuture={true}
                onChange={(e) => {
                  setPage(0);
                  setEndDateSearchQuery({
                    isValid: emptyCheck(e),
                    value: e,
                  });
                }}
                value={endDateSearchQuery}
                error={!endDateSearchQuery?.isValid}
                errorMsg={"To date is required"}
                size={"16rem"}
              />
            </Box>

            {/* Status Filter */}
            <FormControl
              size="medium"
              sx={{ minWidth: 200, bgcolor: "white", borderRadius: 2 }}
            >
              <InputLabel sx={{ fontSize: "12px" }}>Status</InputLabel>
              <Select
                value={statusFilter}
                label="Status"
                onChange={(e) => setStatusFilter(e.target.value)}
                sx={{ fontSize: "12px" }}
              >
                <MenuItem value="all" sx={{ fontSize: "12px" }}>
                  All
                </MenuItem>
                <MenuItem value="1" sx={{ fontSize: "12px" }}>
                  Approved
                </MenuItem>
                <MenuItem value="2" sx={{ fontSize: "12px" }}>
                  Pending
                </MenuItem>
                <MenuItem value="3" sx={{ fontSize: "12px" }}>
                  Rejected
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>

        {/* ===== Table Section ===== */}
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : (
          <Paper
            elevation={4}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              backdropFilter: "blur(6px)",
              background: "rgba(255,255,255,0.9)",
            }}
          >
            <TableContainer>
              <Table>
                {/* ===== Table Head ===== */}
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "rgb(224, 233, 238)",
                      "& .MuiTableCell-root": {
                        "&:focus": {
                          backgroundColor: "rgb(224, 233, 238) !important",
                        },
                      },
                    }}
                  >
                    {[
                      ["company_name", "Company Name"],
                      ["first_name", "First Name"],
                      ["last_name", "Last Name"],
                      ["company_official_email", "Email"],
                      ["created_on", "Onboarded Date"],
                      ["is_approved", "Status"],
                    ].map(([field, label]) => (
                      <TableCell
                        key={field}
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          textTransform: "uppercase",
                          border: "none",
                          fontFamily: "GilroySemiBold",
                          whiteSpace: "nowrap",
                          // overflow:"hidden",
                          textOverflow: "ellipsis",

                          py: 2,
                          "&:focus": {
                            backgroundColor: "rgb(224, 233, 238) !important",
                            outline: "none",
                          },
                        }}
                      >
                        {renderSortLabel(field, label)}
                      </TableCell>
                    ))}

                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        textAlign: "center",
                        border: "none",
                        fontFamily: "GilroySemiBold",
                        py: 2,
                        "&:focus": {
                          backgroundColor: "rgb(224, 233, 238) !important",
                          outline: "none",
                        },
                      }}
                    >
                      Documents
                    </TableCell>

                    {access_type !== "Buyer" && (
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          textTransform: "uppercase",
                          textAlign: "center",
                          border: "none",
                          fontFamily: "GilroySemiBold",
                          py: 2,
                          "&:focus": {
                            backgroundColor: "rgb(224, 233, 238) !important",
                            outline: "none",
                          },
                        }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>

                {/* ===== Table Body ===== */}
                <TableBody>
                  {vendors.map((vendor, index) => (
                    <TableRow
                      key={vendor.token}
                      sx={{
                        backgroundColor: "white",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                        borderBottom: "1px solid #97979720",
                      }}
                    >
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          border: "none",
                          py: 2,
                          fontFamily: "GilroyMedium",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {vendor.company_name || "-"}
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: "14px",
                          border: "none",
                          py: 2,
                          fontFamily: "GilroyMedium",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {vendor.first_name || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          border: "none",
                          py: 2,
                          fontFamily: "GilroyMedium",
                          maxWidth: "100px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {vendor.last_name || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          border: "none",
                          py: 2,
                          fontFamily: "GilroyMedium",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {vendor.company_official_email || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          border: "none",
                          py: 2,
                          fontFamily: "GilroyMedium",
                          maxWidth: "100px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {formatDate(vendor.created_on)}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          border: "none",
                          py: 2,
                          fontFamily: "GilroyMedium",
                        }}
                      >
                        {vendor.is_approved === 1 ? (
                          <Chip
                            icon={<VerifiedIcon />}
                            label="Approved"
                            color="success"
                            size="small"
                            sx={{ fontWeight: 600, fontSize: "12px" }}
                          />
                        ) : vendor.is_approved === 2 ? (
                          <Chip
                            icon={<HourglassBottom />}
                            label="Pending"
                            color="warning"
                            size="small"
                            sx={{ fontWeight: 600, fontSize: "12px" }}
                          />
                        ) : (
                          <Chip
                            icon={<DisabledByDefault />}
                            label="Rejected"
                            color="error"
                            size="small"
                            sx={{ fontWeight: 600, fontSize: "12px" }}
                          />
                        )}
                      </TableCell>

                      {vendor.vendor_docs &&
                      Object.keys(vendor.vendor_docs).length > 0 ? (
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            border: "none",
                            py: 2,
                            fontFamily: "GilroyMedium",
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            cursor: "pointer",
                          }}
                          onClick={() => handleOpen(vendor)}
                        >
                          <FilePresentRoundedIcon
                            color="primary"
                            sx={{ fontSize: "20px" }}
                          />
                          <span>View Document</span>
                        </TableCell>
                      ) : (
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            border: "none",
                            py: 2,
                            fontFamily: "GilroyMedium",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            color: "#504c4cff",
                          }}
                        >
                          <InsertDriveFileOutlinedIcon
                            sx={{ fontSize: "20px" }}
                          />
                          No document
                        </TableCell>
                      )}

                      {access_type !== "Buyer" && (
                        <TableCell
                          sx={{
                            textAlign: "center",
                            borderBottom: "none",
                            py: 2,
                          }}
                        >
                          {vendor.is_approved === 2 ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 1,
                              }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() =>
                                  approveVendor(vendor.token, "approve")
                                }
                                sx={{
                                  fontSize: "11px",
                                  fontWeight: 600,
                                  borderRadius: 1,
                                  px: 1.5,
                                  py: 0.5,
                                  minWidth: "auto",
                                }}
                              >
                                Approve
                              </Button>
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() =>
                                  approveVendor(vendor.token, "reject")
                                }
                                sx={{
                                  fontSize: "11px",
                                  fontWeight: 600,
                                  borderRadius: 1,
                                  px: 1.5,
                                  py: 0.5,
                                  minWidth: "auto",
                                }}
                              >
                                Reject
                              </Button>
                            </Box>
                          ) : (
                            <span
                              style={{ fontStyle: "italic", color: "#888" }}
                            >
                              -
                            </span>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}

                  {vendors.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        align="center"
                        sx={{ py: 4, border: "none" }}
                      >
                        No matching vendors found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              sx={{
                "& .MuiTablePagination-toolbar": { fontSize: "13px" },
              }}
            />
          </Paper>
        )}

        {/* Document model */}
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              width: "100%",
              maxWidth: 1000,
              borderRadius: 2,
            },
          }}
        >
          <DialogTitle
            sx={{
              fontFamily: "GilroyBold",
              fontSize: "16px",
            }}
          >
            Vendor Documents
          </DialogTitle>

          <DialogContent dividers>
            <Grid container spacing={2}>
              {selectVendor &&
                Object.entries(selectVendor.vendor_docs || {}).map(
                  ([key, value], i) => (
                    <Grid item xs={6} sm={4} md={3} key={`${key}-${i}`}>
                      {value ? (
                        <ImageView
                          imgSrc={value.replace(
                            "https://teckost.s3.amazonaws.com",
                            process.env.REACT_APP_CLOUDFRONT_URL
                          )}
                          label={key
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                        />
                      ) : (
                        <ImageView
                          imgSrc={noImageAvailable}
                          label={key
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                        />
                      )}
                    </Grid>
                  )
                )}
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} variant="contained" color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Fade>
  );
};

export default VendorApproval;
